import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import cx from "classnames";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

import { useTranslation } from "@/core/i18n";
import { useGetCurrentPlatform } from "api/orval/platform/platform";
import Logo from "assets/images/RepeatMD_myRepeat.svg";
import { hasConfiguredAdTracking } from "modules/analytics/AdPixels/adTrackingOptOut";
import { PRIVACY_CHOICES_PATH } from "modules/privacyChoices/privacyChoicesRoute";
import { handleLinkClick } from "utils/androidByPassDeepLinkClick";
import { getAdminUrl } from "utils/functions";
import { isNativeMobileApp } from "utils/platform.helpers";

type RepeatMDFooterProps = {
  showLinks?: boolean;
  showShopTerms?: boolean;
};

export const RepeatMDFooter = (props: RepeatMDFooterProps) => {
  const { t } = useTranslation();
  const logo = <Logo className="fill-dark-grey" />;
  const anchorRef = useRef(null);
  const { data: platform } = useGetCurrentPlatform({ query: { enabled: !!props.showLinks } });
  return (
    <div>
      <div className={cx("flex w-full items-center justify-center", "p-4")}>
        <div className={cx("mr-1 text-body3 text-dark-grey")}>{t("repeatmdFooter.poweredBy")}</div>
        {logo}
      </div>
      {props.showLinks && (
        <div className="flex items-center justify-center gap-6 px-5 pb-7 pt-3">
          <button
            className="text-bold3 text-secondary"
            rel="noopener noreferrer"
            onClick={() => Browser.open({ url: "https://myrepeat.com/terms.html" })}
          >
            {t("repeatmdFooter.termsOfService")}
          </button>
          <button
            className="text-bold3 text-secondary"
            rel="noopener noreferrer"
            onClick={() => Browser.open({ url: "https://myrepeat.com/privacy-policy.html" })}
          >
            {t("repeatmdFooter.privacyPolicy")}
          </button>
          {hasConfiguredAdTracking(platform?.adTracking) && (
            <Link className="text-bold3 text-secondary" to={PRIVACY_CHOICES_PATH}>
              {t("privacyChoices.footerLink")}
            </Link>
          )}
          {!isNativeMobileApp() && (
            <a
              ref={anchorRef}
              className="text-bold3 text-secondary"
              href={getAdminUrl()}
              target="_self"
              rel="noopener noreferrer"
              onClick={() => {
                handleLinkClick(anchorRef);
              }}
            >
              {t("repeatmdFooter.admin")}
            </a>
          )}
        </div>
      )}
      {props.showShopTerms && (
        <span
          className={cx(
            "flex w-full justify-center gap-1 pb-1 text-chip text-primary",
            "flex-wrap font-normal",
          )}
        >
          <Trans
            i18nKey="repeatmdFooter.shopTermsAgreement"
            components={{
              privacy: (
                <button
                  className="text-brand-color"
                  rel="noopener noreferrer"
                  onClick={() => Browser.open({ url: "https://myrepeat.com/privacy-policy.html" })}
                />
              ),
              terms: (
                <button
                  className="text-brand-color"
                  rel="noopener noreferrer"
                  onClick={() => Browser.open({ url: "https://myrepeat.com/terms.html" })}
                />
              ),
            }}
          />
        </span>
      )}
    </div>
  );
};
